import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * 客户端相关
 */
export const usePClientStore = defineStore('client', () => {
  /**
   * 是否出现过引导页面
   */
  const guide = ref(false);
  /**
   * 添加资源的按钮状态
   */
  const disableAddResourceBtn = ref(true);

  // /**
  //  * 设置引导开关
  //  * @param value - 开关状态
  //  */
  // function setGuide(value: boolean) {
  //   guide.value = value;
  // }

  /**
   * 设置添加资源按钮的开关状态
   * @param disableAddResourceBtn - 添加资源按钮的开关状态
   */
  function enableAddResourceBtnStatus(value: boolean) {
    disableAddResourceBtn.value = value;
  }

  return {
    guide,
    disableAddResourceBtn,
    enableAddResourceBtnStatus,
  };
});
